import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OfferInstance } from '@assetaccountant/core/models/offers/offer-instance';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AzureMarketPlaceService {
  constructor(private http: HttpClient) {}

  getOfferFromToken(token: string): Observable<OfferInstance> {
    return this.http.get<OfferInstance>(
      `${environment.servicesApiUrl}/api/v3/azure-market-place?token=${encodeURIComponent(token)}`,
    );
  }
}
